'use strict'
const formatter = new Intl.NumberFormat('de-DE');
import SimulatorGraph from './lib/SimulatorGraph';
import Inputmask from "inputmask";

class Simulator {
    
    constructor() {
        this.data = [];
        this.options = {
            
        };
        this.setOptions({
            sexo: $('input[name="sexo"]').is(':checked')?'F':'M',
            fecha_nacimiento: $('#fecha_nacimiento').val(),
            cantidad_hijos: 0,
            worked_years:$('#workedYears').val()*1,
            saldo_afap:'',
            saldo_fav:0,
            ahorro_unico:0,
            monthly_savings:0,
            es_trabajador_nuevo: $('input[name="es_trabajador_nuevo"]:checked').length==1?true:false,
            salary:$('#salary').val()*1>0?$('#salary').val()*1:1000,
       });     

        this.simulator_graph = new SimulatorGraph();
        this.simulator_char = new SimulatorHighcharts();
    }

    setOptions(options){
        this.options = options;
    }

    formControlDisable(disable){
        $("#workedYears").data("ionRangeSlider").update({disable: disable});
        $("#salary").data("ionRangeSlider").update({disable: disable});
        $("#monthly_savings").data("ionRangeSlider").update({disable: disable});
        $('input[name="sexo"]').attr('disabled', disable);
        $('input[name="es_trabajador_nuevo"]').attr('disabled', disable);
        $('input[name="saldo_afap"]').attr('disabled', disable);
        $('input[name="saldo_fav"]').attr('disabled', disable);
        $('input[name="ahorro_unico"]').attr('disabled', disable);
        $('input[name="fecha_nacimiento"]').attr('disabled', disable);
        $('input[name="cantidad_hijos"]').attr('disabled', disable);
    }

    loaderCalcInfo(disable) {
        if (disable)
            $('[data-var="retirement"], [data-var="afap_retirement"], [data-var="bps_retirement"]').addClass('dots');
        else
            $('[data-var="retirement"], [data-var="afap_retirement"], [data-var="bps_retirement"]').removeClass('dots');
    }

    allVal (val){
        let options = Object.assign({}, this.options);
        return Object.assign(options, val);
    }
    
    init () {
        var self=this;
        $('input[name="sexo"]').on('change', (e) => {
            this.load(this.allVal({sexo:$(e.currentTarget).is(':checked') ? 'F' : 'M'}));
        });        
        $('input[name="es_trabajador_nuevo"]').on('change', (e) => {
            this.load(this.allVal({es_trabajador_nuevo:$(e.currentTarget).is(':checked') ? true : false}));
        });        
        $('input[name="cantidad_hijos"]').on('input', (e) => {
            this.load(this.allVal({cantidad_hijos:$(e.currentTarget).val()}));
        });  

        self.initInputChange($('input[name="saldo_afap"]'));
        self.initInputChange($('input[name="saldo_fav"]'));
        self.initInputChange($('input[name="ahorro_unico"]'));

        $("#ageRange").ionRangeSlider({
            skin: "round",
            //type: "double",
            min: 15,
            max: 79,
            step: 1,
            //to_min: 60,
            //to_max: 80, 
            //from: 2,
            //to: 2,
            postfix: " años",
            hide_min_max: true,
            hide_from_to: true,
            onChange: (data) => {
                var data=this.simulator_char.getData(data.from);
                var values = Object.values(data);
                console.log(values);
                $('[data-var="afap_retirement"]').html(values[4].toLocaleString());
                $('[data-var="bps_retirement"]').html(values[3].toLocaleString());
                $('[data-var="age_range_to"]').html(values[0]);
                $('[data-var="retirement"]').html(values[4].toLocaleString());
            }
        });
    
        $("#workedYears").ionRangeSlider({
            skin: "round",
            min: 0,
            max: 79,
            from: this.options.worked_years,
            postfix: " años",
            hide_min_max: true,
            onFinish: (data) => {
                this.load(this.allVal({worked_years:data.from}));
            }
        });  
        
        var selector = document.getElementById("fecha_nacimiento");
        var im = new Inputmask("", { 
            alias: "datetime", 
            inputFormat: "dd/mm/yyyy",
            "oncomplete": function(a){ 
                var maxValue=self.calcularEdad($(a.target).val())-14;

                self.load(self.allVal({fecha_nacimiento:$(a.target).val(), worked_years: Math.min(maxValue, self.options.worked_years)}));
                $("#workedYears").data("ionRangeSlider").update({
                    max: maxValue,
                    from: self.options.worked_years,
                });

            },
        });
        im.mask(selector);

        var selector = document.getElementById("cantidad_hijos");
        var im = new Inputmask("numeric", { min: 0, max: 10});
        im.mask(selector);

        $("#salary").ionRangeSlider({
            skin: "round",
            min: 1000,
            max: $("#salary").data('max'),
            from: this.options.salary,
            prefix: "$",
            prettify_separator: ".",
            step: 1000,
            hide_min_max: true,
            onChange: (data) => {
                if(data.from==data.max){
                    $('.form-range__label_desclaimer').show();
                }else{
                    $('.form-range__label_desclaimer').hide();
                }
            },
            onFinish: (data) => {
                this.load(this.allVal({salary:data.from, monthly_savings:0}));
            }
        });
    
        $("#monthly_savings").ionRangeSlider({
            skin: "round",
            min: 0,
            max: 100000,
            from: this.options.monthly_savings,
            prefix: "$",
            step: 1000,
            prettify_separator: ".",
            hide_min_max: true,
            onFinish: (data) => {
                this.load(this.allVal({monthly_savings:data.from}));
            }
        });

        $("#simViewMore").on('click', function(e) {
            e.preventDefault();
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).text('Ver más');
                $("#viewMoreContent").slideUp();
            } else {
                $(this).addClass('active');
                $(this).text('Ver menos');
                $("#viewMoreContent").slideDown();
            }
        });

        this.load(this.options);
    }

    load(options, success = null){
        var self=this;

        $.var('message').hide();

        $.var({
            monthly_savings: formatter.format(options.monthly_savings),
        });
        if(
            this.data.length === 0 || 
            options.worked_years !== this.options.worked_years || 
            options.monthly_savings !== this.options.monthly_savings || 
            options.salary !== this.options.salary || 
            options.saldo_afap !== this.options.saldo_afap || 
            options.saldo_fav !== this.options.saldo_fav || 
            options.ahorro_unico !== this.options.ahorro_unico || 
            options.sexo !== this.options.sexo || 
            options.es_trabajador_nuevo !== this.options.es_trabajador_nuevo || 
            options.actividad_bonificada !== this.options.actividad_bonificada ||
            options.giro_actividad !== this.options.giro_actividad ||
            options.cantidad_hijos !== this.options.cantidad_hijos ||
            options.densidad_cotizacion !== this.options.densidad_cotizacion
            ){
            this.setOptions(options);
            this.formControlDisable(true);
            this.loaderCalcInfo(true);
            $.var({
                retirement:'<span class="dots">...</span>',
                bps_retirement: '<span class="dots">...</span>',
                afap_retirement: '<span class="dots">...</span>'
            });
            $.ajax({
                url: App.baseUrl + '/ajax/simulador-de-jubilacion',
                type : "GET",
                dataType : 'json',
                data:options,
                cache: true,
                success : (data) => {
                    self.formControlDisable(false);
                    self.loaderCalcInfo(false);
                    if(data.status === 1 && data.result.length > 0){
                        self.data = data.result;

                        this.simulator_graph = new SimulatorGraph(data.result);
                        if($('#chart') && $('#chart').length > 0){
                            this.simulator_char = (new SimulatorHighcharts(self.data)).prepare().render();
                        
                            $("#ageRange").data("ionRangeSlider").update({
                                min: this.simulator_char.getYearMin(),
                                max: this.simulator_char.getYearMax(),
                                from: 0,
                                
                            });
                            var data=this.simulator_char.getData(0);
                            var values = Object.values(data);
                            $('[data-var="afap_retirement"]').html(values[4].toLocaleString());
                            $('[data-var="bps_retirement"]').html(values[3].toLocaleString());
                            $('[data-var="age_range_to"]').html(values[0]);
                            $('[data-var="retirement"]').html(values[4].toLocaleString());
                            //$('#graph_range_age').find('.irs-handle.single').append('<span class="irs-handle-line"></span>');
                            //$('.irs-handle-line').height(this.simulator_char.getHeight(options.age_range.from));
                        }
                        //let info = this.simulator_graph.filter(options.age_range.to);



                        self.render(self.data, options);
                    } else {
                        $.var('message').text(data.message).show();
                        $('#viewMoreContent .box').hide();
                    }
                },
                error: function(xhr, resp, text) {
                    //console.log(xhr, resp, text);
                    self.formControlDisable(false);
                    self.render(false, false);
                }
            });
            return;
        }

        this.setOptions(options);
        this.render(this.data, options);
    }

    render (data, options) {
        $('#viewMoreContent .paginator ul').html('');
        var table=$('#viewMoreContent table.table tbody');
        table.html('');

        $.var('message').text('').hide();

        if(!data){
            $('#viewMoreContent .box').addClass('d-none').removeClass('d-flex');
            $.var('message').text('No se encontraron datos.').show();
            return false;
        }
        
        $('#viewMoreContent .box').removeClass('d-none').addClass('d-flex');

        var min=100;
        var max=0;
        for(var i in data){
            let values = Object.values(data[i]);
            if(values[1]!=0){
                min=Math.min(min, values[0]);
                max=Math.max(max, values[0]);
                table.append('<tr>'
                +'<td>'+values[0]+'</td>'
                //+'<td>'+values[3].toLocaleString()+'</td>'
                +'<td>'+values[4].toLocaleString()+'</td>'
                //+'<td>'+values[5].toLocaleString()+'</td>'
                +'</tr>');
            }
        }

        var cont=0;
        var block=5;
        for(var i=min;i<=max;i=i+block){
            $('#viewMoreContent .paginator ul').append('<li><a href="#" data-min="'+cont+'" data-max="'+(cont+block)+'">'+i+'-'+Math.min(i+4, max)+'</a></li>');
            cont=cont+block;
        }

        $('#viewMoreContent .paginator ul a').on('click', function(evt){
            evt.preventDefault();
            $('#viewMoreContent .paginator ul li.active').removeClass('active');
            $(this).closest('li').addClass('active');

            $('#viewMoreContent table.table tbody tr').hide();
            $('#viewMoreContent table.table tbody tr').slice($(this).attr('data-min'), $(this).attr('data-max')).show();

        });
        $('#viewMoreContent .paginator ul a:first').trigger('click');
    }

    initInputChange(input){
        var self=this;

        var name=input.attr('name');

        if(typeof self.lastValue=='undefined'){
            self.lastValue={};
            self.lastChangeTimestamp={};
            self.inputChange={};
        }

        self.lastValue[name]='';
        self.lastChangeTimestamp[name]=0;
        self.inputChange[name]=false;

        input.on('input', (e) => {
            self.inputChange[name]=true;

            const currentTime = Date.now();
            const currentValue = $(e.currentTarget).val();
            
            if (currentValue !== self.lastValue[$(e.currentTarget).attr('name')]) {
                self.lastValue[$(e.currentTarget).attr('name')] = currentValue;
                self.lastChangeTimestamp[$(e.currentTarget).attr('name')] = currentTime;
            }
            
        });
        setInterval(() => {
            const currentTime = Date.now();
            const inactiveTime = currentTime - self.lastChangeTimestamp[name];
            if (inactiveTime > 1000 && self.inputChange[name]) {
                self.inputChange[name]=false;
                this.load(this.allVal({[name]:$('input[name="'+name+'"]').val()}));
            }
        }, 1000);

        var selector = document.getElementById(input.attr('id'));
        var im = new Inputmask("", {
            alias: "currency",
            groupSeparator: '.',
            radixPoint: ',',
            prefix: '$ ',
            digits: 0,
            allowMinus: false,
            //"oncomplete": function oncomplete(a) {
            //    self.load(self.allVal({ saldo_afap: $("#saldo_afap").val() }));
            //}
        });
        im.mask(selector);

    }

    calcularEdad(fechaNacimiento) {
        const partesFecha = fechaNacimiento.split('/');
        const dia = parseInt(partesFecha[0], 10);
        const mes = parseInt(partesFecha[1], 10) - 1;
        const año = parseInt(partesFecha[2], 10);
    
        const fechaNacimientoDate = new Date(año, mes, dia);
        const hoy = new Date();
    
        let edad = hoy.getFullYear() - fechaNacimientoDate.getFullYear();
    
        const mesActual = hoy.getMonth();
        const diaActual = hoy.getDate();
    
        if (mesActual < mes || (mesActual === mes && diaActual < dia)) {
            edad--;
        }
        return edad;
    }
}

export default Simulator;